<template>
  <form class="ic-form" @submit.prevent="onSubmit">
    <div class="ic-form__row">
      <label class="ic-field">
        <span class="ic-field__label">Nome</span>
        <input data-testid="firstName" class="ic-field__input" type="text" v-model.trim="form.firstName" />
      </label>
      <label class="ic-field">
        <span class="ic-field__label">Cognome</span>
        <input data-testid="lastName" class="ic-field__input" type="text" v-model.trim="form.lastName" />
      </label>
    </div>

    <label class="ic-field">
      <span class="ic-field__label">Email</span>
      <input data-testid="email" class="ic-field__input" type="email" v-model.trim="form.email" />
    </label>

    <label class="ic-field">
      <span class="ic-field__label">Nome dell'agenzia</span>
      <input data-testid="agencyName" class="ic-field__input" type="text" v-model.trim="form.agencyName" />
    </label>

    <label class="ic-field">
      <span class="ic-field__label">Sede dell'agenzia</span>
      <address-autocomplete-field v-model="form.agencyAddress" placeholder="Indirizzo dell'agenzia" />
    </label>

    <privacy-consent-checkbox v-model="form.privacy" test-id="privacy" />

    <div class="ic-form__actions">
      <button data-testid="submit" type="submit" class="ic-form__submit" :disabled="!isValid">Invia richiesta</button>
    </div>
  </form>
</template>

<script>
import AddressAutocompleteField from '@/components/forms/AddressAutocompleteField.vue';
import PrivacyConsentCheckbox from '@/components/forms/PrivacyConsentCheckbox.vue';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'AgencyContactForm',
  components: { AddressAutocompleteField, PrivacyConsentCheckbox },
  emits: ['submit'],
  data() {
    return {
      form: { firstName: '', lastName: '', email: '', agencyName: '', agencyAddress: '', privacy: false },
    };
  },
  computed: {
    isValid() {
      const f = this.form;
      return (
        !!f.firstName && !!f.lastName && EMAIL_RE.test(f.email) &&
        !!f.agencyName && !!f.agencyAddress && f.privacy === true
      );
    },
  },
  methods: {
    onSubmit() {
      if (!this.isValid) return;
      // Questo form non scrive su Firestore (solo email via sendAgencyContactEmails,
      // vedi services/agencyContact.js): niente documento dove salvare privacyConsent,
      // quindi la spunta resta locale e non entra nel payload emesso (#708).
      const { privacy, ...payload } = this.form; // eslint-disable-line no-unused-vars
      this.$emit('submit', { ...payload });
    },
  },
};
</script>
